<template>
    <div class="business">
      <mHead :classType="'light'" :showSearch="true"></mHead>
      <div class="main">
            <div class="title">
                资讯
            </div>
            <div class="list" v-if="list.length > 0">
                <div class="item" v-for="item in list" :key="item.id" @click="toDetail(item)">
                    <img :src="item.imageUrl" alt="">
                    <p class="name">
                        {{item.name}}
                    </p>
                    <p class="time">
                        <span>{{item.author}}</span> <span>{{item.createTime | formatDate('MM/dd/yyyy')}}</span>
                    </p>
                </div>
            </div>
            <div class="nodata" v-else>
                <p>暂无数据...</p>
            </div>
            <div class="more" @click="changePage" v-if="selectNum<(pageNum-1)">查看更多</div>
      </div>
      <mBottom :classType="'light'"></mBottom>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    components:{ mHead, mBottom },
    data() {
        return {
            imgList: [],
            pageNum: 0,
            selectNum: 0,
            allList: [], 
            list: [
            
            ]
        }
    },
    computed: mapState({
    // 映射 this.count 为 store.state.count
       
        // swiper() {
        //     return this.$refs.mySwiper.swiper
        // },
    }),
    mounted(){
        this.statistics();
        this.getInfoList();
    },
    beforeDestroy(){
        
    },
    methods: {
        getInfoList(){
            this.$http.get( this.service.dev.api.infoList ).then(response =>{
              if(response.status == 200){
                  let list = (response.body || []).filter(item => {
                      return item.status == 1;
                  })
                  this.allList = list;
                  this.pageNum = Math.ceil(list.length/4);
                  this.list = list.slice(this.selectNum, 4);
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        changePage() {
            if((this.pageNum - 1) > this.selectNum) {
                this.selectNum = this.selectNum + 1;
            
                this.list = [...this.list, ...this.allList.slice(this.selectNum*4, this.selectNum*4+4)]
            }
        },
        toDetail(item) {
            this.$router.push('/businessDetail/'+ item.id)
        },
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '资讯列表'} ).then(response =>{
              
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/base.scss";
    .business {
        background: #FAFAFA;
        .main {
            text-align: left;
            margin: poToRem(54) 0 0;
            .title {
                font-size: poToRem(24);
                padding: poToRem(20);
            }
            .nodata {
                margin-top: poToRem(80);
                text-align: center;
            }
            .list {
                width: 100%;
                padding: 0 poToRem(20);
                box-sizing: border-box;
                .item {
                    width: 100%;
                    display: inline-block;
                    margin-bottom: poToRem(36);
                    cursor: pointer;
                    img{
                        width: 100%;
                        display: block;
                    }
                    .name {
                        font-size: poToRem(14);
                        margin-top: poToRem(12);
                    }
                    .time {
                        font-size: poToRem(12);
                        color: rgba(0, 0, 0, 0.4);
                        margin-top: poToRem(8);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                }
            }
            .more {
                width: poToRem(180);
                height: poToRem(42);
                line-height: poToRem(42);
                border: 1px solid;
                font-size: poToRem(12);
                text-align: center;
                margin: poToRem(40) auto 0;
            }
        }
    }


</style>
<style lang="scss">
    .business {
        .main {
            .list {
                .item {
                    .content {
                        >div {
                            display: inline!important;
                        }
                    }
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/modules/view/business/mobile.vue